import { useLocation, matchPath } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Mapování z nové do staré Carkulky pro vybrané stránky
export const useOldAppPath = () => {
    const authCtx = useAuth()
    const currentLocation = useLocation();

    if (!authCtx?.user?.enableSwithToOldApp)
        return undefined


    let match = matchPath('/carkulka/concepts', currentLocation.pathname);
    if (match)
        return 'InsuranceWizard/Index2?listType=1';

    match = matchPath('/carkulka/contracts', currentLocation.pathname);
    if (match)
        return 'InsuranceWizard/Index2?listType=2'

    match = matchPath('/carkulka', currentLocation.pathname);
    if (match)
        return 'Home/Index'

    match = matchPath('/carkulka/wizard/1/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'InsuranceWizard-1/' + match.params.insuranceParamsId

    match = matchPath('/carkulka/wizard/2/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'InsuranceWizard-1/' + match.params.insuranceParamsId

    match = matchPath('/carkulka/wizard/3/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'InsuranceWizard-2/' + match.params.insuranceParamsId

    match = matchPath('/carkulka/wizard/4/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'InsuranceWizard-3/' + match.params.insuranceParamsId

    match = matchPath('/carkulka/wizard/5/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'InsuranceWizard-5/' + match.params.insuranceParamsId

    match = matchPath('/carkulka/extra/wizard/1/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'AddOnWizard-1/' + match.params.insuranceParamsId

    match = matchPath('/carkulka/extra/wizard/2/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'AddOnWizard-2/' + match.params.insuranceParamsId

    match = matchPath('/carkulka/extra/wizard/3/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'AddOnWizard-3/' + match.params.insuranceParamsId

    match = matchPath('/carkulka/extra/wizard/4/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'AddOnWizard-4/' + match.params.insuranceParamsId

    match = matchPath('/carkulka/news', currentLocation.pathname);
    if (match)
        return 'Home/Index?infoCount=0'

    match = matchPath('/chaloupka/concepts', currentLocation.pathname);
    if (match)
        return 'Property/InsuranceWizard/Index1?listType=1';

    match = matchPath('/chaloupka/contracts', currentLocation.pathname);
    if (match)
        return 'Property/InsuranceWizard/Index1?listType=2'

    match = matchPath('/chaloupka', currentLocation.pathname);
    if (match)
        return 'Property'

    match = matchPath('/chaloupka/wizard/1/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'Property/InsuranceWizard-1/' + match.params.insuranceParamsId

    match = matchPath('/chaloupka/wizard/2/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'Property/InsuranceWizard-1/' + match.params.insuranceParamsId

    match = matchPath('/chaloupka/wizard/3/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'Property/InsuranceWizard-2/' + match.params.insuranceParamsId

    match = matchPath('/chaloupka/wizard/4/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'Property/InsuranceWizard-3/' + match.params.insuranceParamsId

    match = matchPath('/chaloupka/wizard/5/:insuranceParamsId', currentLocation.pathname);
    if (match)
        return 'Property/InsuranceWizard-5/' + match.params.insuranceParamsId

    match = matchPath('/chaloupka/news', currentLocation.pathname);
    if (match)
        return 'Property?infoCount=0'

    return null;
}